import * as _ from "lodash";
import gsap from 'gsap';
import { DatePipe } from "@angular/common";
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CalendarEventTitleFormatter, CalendarView } from "angular-calendar";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { UserRole, UserSelectedPlan } from "src/app/Enum/Enum";
import { Country } from "src/app/models/Country";
import { LandingPageSearchModel } from "src/app/models/LandingPageSearchModel";
import { Port } from "src/app/models/Port";
import { portcalvm } from "src/app/models/portcalpostmodel";
import { Result } from "src/app/models/ResultModel";
import { InfoSectionService } from "../landing/services/infosection.service";
import { ShippingLineService } from "../landing/services/shippinglines.service";
import { CustomEventTitleFormatter } from "../portfullcalendar/CalendarEventTitleFormatterOvrride";
import { AdminViewModel } from "src/app/models/AdminViewModel";
import { VoyageModel } from "../voyagetrackersplash/voyage.model";
import { VesselService } from "../landing/services/vessel.service";
import { VoyageService } from "../landing/services/voyage.service";

@Component({
    templateUrl: "./schedule.component.html",
    styleUrls: ["./schedule.component.scss"],
    providers: [ShippingLineService, InfoSectionService, DatePipe, {
      provide: CalendarEventTitleFormatter,
      useClass: CustomEventTitleFormatter,
    }],
    styles: [
      `.cell-totals {
        margin: 5px;
        text-align: center;
      }
      .badge {
        margin-right: 5px;
      }
      .custom-event {
        border: 1px solid silver;
      }
    `
    ]
  })
  export class ScheduleComponent {
    shippingLines = [];
  infoSections = [];
  view: CalendarView = CalendarView.Week;
  totalSearchCount: number = 0;
  isBasicPlan: boolean = false;
  isLoggedIn: boolean = false;
  registerUrl: string;
  currentUserDetails: any;
  BremerPortId: number = 0;
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  constructor(
    private modal: NgbModal,
    public datepipe: DatePipe,
    private shippingLineService: ShippingLineService,
    private infoSectionService: InfoSectionService,
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private vesselService: VesselService,
    private voyageService: VoyageService,
  ) {
    this.registerUrl = window.location.origin + '/signup';
    var currentUser = localStorage.getItem('currentUser');
    this.portForm.controls.date.setValue(new Date() as any);
    if (currentUser) {
      this.isLoggedIn = true;
      this.currentUserDetails = JSON.parse(currentUser);

      if (this.currentUserDetails && this.currentUserDetails.usersDetailsVM && (this.currentUserDetails.usersDetailsVM.userRole != null && this.currentUserDetails.usersDetailsVM.userRole != '')) {
        if (this.currentUserDetails.usersDetailsVM.userRole == UserRole.User) {
          if (this.currentUserDetails.usersDetailsVM.planId != null && this.currentUserDetails.usersDetailsVM.planId == UserSelectedPlan.Basic) {
            this.totalSearchCount = this.currentUserDetails.usersDetailsVM.totalSearchCount;
            this.isBasicPlan = true;
          }
        }
      }
    }
  }

  ports: Port[];
  portsData: Port[] = [];
  portCount: number;
  portName: string;
  submitted: boolean = false;
  shippinglineslist: any;
  voyagelist: any = [];
  vesselslist: any;
  minDate: Date;
  maxDate: Date;
  rageYears: string;
  events: any;
  viewDate: Date = new Date();
  month: number = -1;
  transit = new portcalvm();
  refresh: Subject<any> = new Subject();

  masterDestinationCountries: Country[] = [];
  masterDestinationPorts: Port[] = [];
  masterSourceCountries: Country[] = [];
  masterSourcePorts: Port[] = [];
  landingPageSearch = new LandingPageSearchModel();
  arrivalPorts: any = [];
  departurePorts: any[];

  portForm = this.fb.group({
    shippingLineId: ["", Validators.required],
    vesselId: ["", Validators.required],
    arrivalPort: ["", Validators.required],
    departurePort: ["", Validators.required],
    date: ["", Validators.required],
    trackNumber: [""]
  });


  ngAfterViewInit() {
    gsap.to('.content', { y: 0, opacity: 1, duration: 0.85 });
  }

  getDetails() {
      if(!this.currentUserDetails){
        this.toastr.error("Please register to see schedules from over 23 different RoRo lines.", "Error!");
        setTimeout(() => {
          this.router.navigateByUrl('/planselection');
         }, 4000);
      }
      else if(this.currentUserDetails.usersDetailsVM.planId != null && this.currentUserDetails.usersDetailsVM.planId == UserSelectedPlan.Basic){
        this.toastr.error("Please upgrade the plan to see schedules from over 23 different RoRo lines..", "Error!");
        setTimeout(() => {
          this.router.navigateByUrl('/planselection');
         }, 4000);
      }
     else if (this.validateForm()) {
        const url = '/' + 'voyagedetail' + '/' + (this.portForm.value.vesselId as any)?.id + '/' + (this.portForm.value.departurePort as any)?.Id + '/' + (this.portForm.value.arrivalPort as any)?.Id + '/' + this.dateConvert(this.portForm.value.date) + '/' + this.dateConvert((this.portForm.value.arrivalPort as any)?.PlannedDate) + '/' + (this.portForm.value.shippingLineId as any)?.id;
        this.router.navigate([url]);
      }
  }


 

  validateForm() {
    if (!(this.portForm.value.shippingLineId as any)?.id) {
      this.toastr.error("Please select Shippingline.", "Error!");
      return false;
    }

    if (!(this.portForm.value.vesselId as any)?.id) {
      this.toastr.error("Please select vessel.", "Error!");
      return false;
    }

    if (!(this.portForm.value.departurePort as any)?.Id) {
      this.toastr.error("Please select departure port.", "Error!");
      return false;
    }

    if (!(this.portForm.value.arrivalPort as any)?.Id) {
      this.toastr.error("Please select arrival port.", "Error!");
      return false;
    }

    if (!this.portForm.value.date) {
      this.toastr.error("Please enter date", "Error!");
      return false;
    }
    return true;
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  ngOnInit() {
    this.minDate = new Date();
    this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);
    localStorage.removeItem('raterequestpage');
    this.shippingLineService
      .getJSON()
      .subscribe(r => this.shippingLines.push(...r));
    this.infoSectionService
      .getJSON()
      .subscribe(i => this.infoSections.push(...i));
    this.getshippingline();
  }

  getshippingline() {
    let model = new AdminViewModel();
    model.pageSize = 1000;
    model.pageNo = 1;
    this.shippingLineService.GetShippingLinesList(model).subscribe((response: any) => {
      if (response && response.data) {
        this.shippinglineslist = _.sortBy(response.data, o => o.companyName);
      } else {
        this.shippinglineslist = null;
      }
    });
  }

  getVesselsByShippingLineId(shippinglineId: number) {
    this.vesselService.GetVesselsdetailsByShippinglineId(shippinglineId, this.dateConvert(this.portForm.value.date)).subscribe((response: any) => {
      this.vesselslist = _.sortBy(response.data, o => o.vesselsName);
    });

  }

  onShippinglineChange(event) {
    this.reset(ControlType.Shippingline);
    this.getVesselsByShippingLineId(event.value.id)
  }

  onVesselChange(event) {
    this.reset(ControlType.Vessel);
    this.voyageService.getVoyageByShippinglineIdAndVesselId((this.portForm.value.shippingLineId as any)?.id, event.value.id,
      this.dateConvert(this.portForm.value.date)).subscribe((result: Result<VoyageModel[]>) => {
        if (result && result.data) {
          this.voyagelist = result.data;
          let ports = [];
          result.data.forEach(item => {
            const date = new Date(item.plannedDate);
            const month = date.toLocaleString('en-us', { month: 'short' })
            ports.push({ Id: item.portId, PortName: item.portName, PlannedDate: item.plannedDate, label: `${item.portName} (${date.getDate()}-${month})` });
          });
          this.departurePorts =_.sortBy(ports, o => o.PlannedDate); 
          if (!this.departurePorts.length || this.departurePorts.length === 1) {
            this.toastr.error("Sorry, We cannot track this vessel.", "Error!");
          }
        }
      });
  }

  onDeparturePortChange(event) {
    this.reset(ControlType.Departure);
    let voyage = this.voyagelist.filter(z => (new Date(z.plannedDate)) > (new Date(event.value.PlannedDate)));
    let ports = [];
    voyage.forEach(item => {
      const date = new Date(item.plannedDate);
      const month = date.toLocaleString('en-us', { month: 'short' });
      ports.push({ Id: item.portId, PortName: item.portName, PlannedDate: item.plannedDate, label: `${item.portName} (${date.getDate()}-${month})` });
    });
    this.arrivalPorts =_.sortBy(ports, o => o.PlannedDate);
    if (!this.arrivalPorts.length) {
      this.toastr.error("Sorry, We cannot track this vessel for this port.", "Error!");
    }
  }

  reset(type) {
    if (type == ControlType.Shippingline || type == ControlType.Date) {
      this.portForm.controls.vesselId.reset();
      this.portForm.controls.vesselId.setValue('');
    }
    if (type == ControlType.Shippingline || type == ControlType.Date || type == ControlType.Vessel || type == ControlType.Departure) {
      this.portForm.controls.arrivalPort.reset();
      this.portForm.controls.arrivalPort.setValue('');
      this.arrivalPorts = [];
    }
    if (type == ControlType.Shippingline || type == ControlType.Date || type == ControlType.Vessel) {
      this.portForm.controls.departurePort.reset();
      this.portForm.controls.departurePort.setValue('');
      this.departurePorts = [];
    }
  }
}

export enum ControlType {
  Shippingline = 1,
  Vessel = 2,
  Arrival = 3,
  Departure = 4,
  Date = 5,
}
